import React, { useState } from "react";
import { Menu, X, MessageCircle } from "lucide-react";
import { Button } from "@/components/ui/button";
import { WHATSAPP_URL } from "@/lib/courseData";

const navItems = [
  { href: "#curriculum", label: "Curriculum" },
  { href: "#pricing", label: "Fees" },
  { href: "#mentor", label: "Mentor" },
  { href: "#faq", label: "FAQ" },
  { href: "#contact", label: "Contact" },
];

const Navbar = () => {
  const [open, setOpen] = useState(false);

  return (
    <header data-testid="site-navbar" className="sticky top-0 z-40 border-b border-white/10 bg-black/60 backdrop-blur-xl">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 h-20 flex items-center justify-between">
        <a href="#top" data-testid="brand-link">
          <img src="/rl-logo.png" alt="RL Trading Institute" className="h-14 w-auto" />
        </a>

        <nav className="hidden md:flex items-center gap-8">
          {navItems.map((n) => (
            <a key={n.href} href={n.href} data-testid={`nav-${n.label.toLowerCase()}`} className="text-sm font-medium text-white/70 hover:text-white transition-colors">
              {n.label}
            </a>
          ))}
        </nav>

        <a href={WHATSAPP_URL} target="_blank" rel="noreferrer" className="hidden md:block" data-testid="nav-enroll-btn">
          <Button className="bg-fin-green text-black hover:bg-fin-green/90 rounded-sm">
            <MessageCircle className="h-4 w-4 mr-2" /> Enroll Now
          </Button>
        </a>

        <button className="md:hidden text-white/80 p-2" onClick={() => setOpen(!open)} data-testid="nav-toggle">
          {open ? <X className="h-5 w-5" /> : <Menu className="h-5 w-5" />}
        </button>
      </div>

      {open && (
        <div className="md:hidden border-t border-white/10 bg-black/95 px-6 py-4 space-y-3">
          {navItems.map((n) => (
            <a key={n.href} href={n.href} onClick={() => setOpen(false)} className="block text-white/80 py-1.5 text-sm" data-testid={`m-nav-${n.label.toLowerCase()}`}>
              {n.label}
            </a>
          ))}
          <a href={WHATSAPP_URL} target="_blank" rel="noreferrer" className="block text-fin-green text-sm font-semibold pt-2 border-t border-white/10" data-testid="m-nav-enroll">
            Enroll on WhatsApp
          </a>
        </div>
      )}
    </header>
  );
};

export default Navbar;
